module.exports = __webpack_public_path__ + "img/album18_31.0358a731.jpg";